import DefaultContainer from '../default_container';
import './index.css';
import constants from '../../constants';
const OfferWall = () => {
  return (
    <DefaultContainer isWelcomeMessage={false}>
      <div className="offer_wall_wrapper">
        <div className="offer_wall_pills_wrapper">
          <div className="offer_wall_pills_container" style={{ height: '100%' }}>
            <div className="offer_wall_pills_tab1">
              <img src={constants.Images.OfferPercentage} />
              <p>155 Offers Available</p>
            </div>
            <div className="offer_wall_pills_tab2">
              <div className="offer_wall_my_coupons_list">My Coupon List</div>
            </div>
          </div>
        </div>
        <div className="offer_wall_offer_card_wrapper">
          <div className="offer_wall_offer_card_container">
            <div className="offer_wall_offer_img_container">
              <img src={constants.Images.NetflixWhiteBg} className="offer_wall_offer_img" />
            </div>
            <div className="offer_wall_coupons_ribbon_container">
              <img
                src={constants.Images.Ribbon_Yellow}
                width="80%"
                style={{ position: 'absolute', right: '22%' }}
              />
              <div style={{ position: 'absolute', left: '3%' }}>
                <b>15</b> Coupons Available
              </div>
            </div>
            <div className="offer_wall_offer_details_container">
              <p className="offer_wall_offer_title">Netflix Special Offer</p>
              <p>1. Must be a new user.</p>
              <p>2. Offer valid till Sep 25th, 2022</p>
            </div>
            <div className="offer_wall_offer_redeem_btn_container">
              <button className="offer_wall_offer_redeem_btn">Redeem</button>
            </div>
            <div className="offer_wall_offer_amount_container">
              <img
                src={constants.Images.Wallet}
                className="offer_wall_offer_wallet_img"
                width="15%"
              />
              <p style={{ paddingLeft: '2%' }}>3250</p>
            </div>
          </div>
        </div>
      </div>
    </DefaultContainer>
  );
};

export default OfferWall;
